import {
  AfterViewInit,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
  ChangeDetectorRef,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LayoutService } from "@sharedV11/services/layouts/layout.service";

@Component({
  selector: "app-panelcustoman",
  templateUrl: "./panel.customan.html",
  styleUrls: ["./panel.customan.css"],
})
export class PanelCustoman implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild("target", { read: ViewContainerRef, static: false })
  target: ViewContainerRef;
  @ViewChild("panel") panel: HTMLElement;
  componentRef: ComponentRef<any>;
  /* @Output() close = new EventEmitter(); */
  @Output() update = new EventEmitter();
  @Input() pkId;
  @Input() mode;
  @Input() ConfigPanel;
  @Input() modificar: boolean = true;
  @Input() otherProps: { [key: string]: any };
  @Input() ConfigData: any;

  private previousBodyOverflow: string | null = null;
  private destroy$ = new Subject<void>();
  overlayLeft = 0;
  sidebarOpened = true;

  constructor(
    private resolver: ComponentFactoryResolver,
    private layoutService: LayoutService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.layoutService.sidebar_opened
      .pipe(takeUntil(this.destroy$))
      .subscribe((opened) => {
        this.sidebarOpened = opened;
        setTimeout(() => {
          this.updateOverlayLeft();
          this.cdr.detectChanges();
        }, 0);
      });
  }

  ngAfterViewInit() {
    this.createComponent(
      this.ConfigPanel,
      this.pkId,
      this.mode,
      this.modificar,
      this.ConfigData,
      this.otherProps
    );

    // Bloqueia o scroll da página de fundo enquanto o painel estiver aberto
    if (typeof document !== "undefined" && document.body) {
      this.previousBodyOverflow = document.body.style.overflow || "";
      document.body.style.overflow = "hidden";
    }

    setTimeout(() => {
      this.updateOverlayLeft();
      this.cdr.detectChanges();
    }, 0);

    //this.panel.scroll({top:0});
    //this.panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ConfigData'] && this.componentRef) {
      this.componentRef.instance.sourceRecord = changes['ConfigData'].currentValue?.sourceRecord;
    }
    //if(changes.paneldoc_config)
    //this.appStatus.paneldoc_open.emit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    // Restaura o estado original do scroll do body
    if (typeof document !== "undefined" && document.body) {
      if (this.previousBodyOverflow !== null) {
        document.body.style.overflow = this.previousBodyOverflow;
      } else {
        document.body.style.overflow = "";
      }
    }
  }

  addDocument(docid: string, doctype: string) {}

  /*   destroy(){
        //this.appStatus.paneldoc_close.emit();
        this.close.emit(null);
    } */

  /*  save() {
        let _that = this;
        this.componentRef.instance.actualizar("guardando...");
        setTimeout(function() {_that.destroy()}, 2000)
        
    } */
  /* submit(){
        this.componentRef.instance.submit();
        this.update.emit(null)

    } */

  createComponent(ConfigPanel, pkId, mode, modificar?, configData?: any, otherProps?: { [key: string]: any }) {
    this.target.clear();
    if (ConfigPanel) {
      const factory: ComponentFactory<any> =
        this.resolver.resolveComponentFactory(ConfigPanel);
      this.componentRef = this.target.createComponent(factory);
      this.componentRef.instance.pkId = pkId;
      this.componentRef.instance.mode = mode;
      // Always propagate boolean inputs (including false) to avoid NG0100 (undefined -> true)
      if (modificar !== undefined) {
        this.componentRef.instance.modificar = modificar;
      }
      if (otherProps) this.componentRef.instance.otherProps = otherProps
      if (this.ConfigData) {
        Object.keys(this.ConfigData).forEach((key) => {
          this.componentRef.instance[key] = this.ConfigData[key];
        });
      }
      if (configData) this.componentRef.instance.sourceRecord = configData.sourceRecord;
      // Ensure the dynamic component is checked with inputs already applied
      this.componentRef.changeDetectorRef.detectChanges();
    }
  }

  private updateOverlayLeft() {
    if (typeof document === "undefined") {
      return;
    }

    if (!this.sidebarOpened) {
      this.overlayLeft = 0;
      return;
    }

    const sidenav = document.querySelector(".main-sidenav") as HTMLElement | null;
    this.overlayLeft = sidenav ? Math.round(sidenav.getBoundingClientRect().width) : 0;
  }
}
